export const actionTypes = {
  FAILED: 'sub-merchant-aggregate/failed',
  LOADING: 'sub-merchant-aggregate/loading',
  SUCCESS: 'sub-merchant-aggregate/success',
  FILTER: 'sub-merchant-aggregate/filter',
  MESSAGE: 'sub-merchant-aggregate/message',
  FORM: 'sub-merchant-aggregate/form',
};

